"use strict";
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.rootHomeZhSagas = void 0;
var effects_1 = require("redux-saga/effects");
var RootPublicPageSaga_1 = require("@/pages/common/sagas/RootPublicPageSaga");
var GlobalAction_1 = require("@/pages/common/actions/GlobalAction");
var HomeZhAction_1 = require("@/pages/homeZh/actions/HomeZhAction");
var SearchHistory_1 = require("@/pages/search/sagas/api/SearchHistory");
var format_1 = require("@/utils/format");
var WindowApi_1 = require("@/api/browser/WindowApi");
var getKeywordSuggestions_1 = require("@/pages/search/sagas/api/getKeywordSuggestions");
var stateFilter_1 = require("@/pages/common/sagas/stateFilter");
var SfilterTypeGroup_1 = require("@/pages/common/states/sfilter/sections/SfilterTypeGroup");
var propertyToUrl_1 = require("@/transformers/propertyToUrl");
var MobilePromoSaga_1 = require("@/pages/common/sagas/MobilePromoSaga");
var FgpPopSagas_1 = require("@/pages/common/sagas/FgpPopSagas");
var getKeyword = function (state) { return state.homeZh.keyword; };
var getSearchType = function (state) { return state.homeZh.searchType === SfilterTypeGroup_1.ListingPurposeType.Rent ? 'rent' : 'buy'; };
var getCurrentKeywordFocus = function (state) {
    var _a, _b;
    if (!state.homeZh.keyword && state.homeZh.keywordHistories.length)
        return ((_a = state.homeZh.keywordHistories.find(function (it) { return it.isFocus; })) === null || _a === void 0 ? void 0 : _a.name) || '';
    if (state.homeZh.isSearchKeywordFocus)
        return state.homeZh.keyword;
    return ((_b = state.homeZh.keywordSuggestions.find(function (it) { return it.isFocus; })) === null || _b === void 0 ? void 0 : _b.name) || state.homeZh.keyword;
};
var watchInit = function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, effects_1.take(GlobalAction_1.default.ON_DOM_LOADED)];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
};
var initKeywordHistories = function () {
    var histories;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, effects_1.call(SearchHistory_1.getSearchHistories)];
            case 1:
                histories = _a.sent();
                return [4 /*yield*/, effects_1.put(HomeZhAction_1.default.setKeywordHistories(histories))];
            case 2:
                _a.sent();
                return [2 /*return*/];
        }
    });
};
var delaySuggestion = function () {
    var keywordInput, keyword, isChinese, minAutocompleteLength, suggestions;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, effects_1.delay(800)];
            case 1:
                _a.sent();
                return [4 /*yield*/, effects_1.put(HomeZhAction_1.default.setKeywordSuggestions([]))];
            case 2:
                _a.sent();
                return [4 /*yield*/, effects_1.select(getKeyword)];
            case 3:
                keywordInput = _a.sent();
                keyword = format_1.default.normalize(keywordInput.trim());
                return [4 /*yield*/, effects_1.call(WindowApi_1.checkIsChinese, keyword)];
            case 4:
                isChinese = _a.sent();
                minAutocompleteLength = isChinese ? 1 : 3;
                if (keyword.length < minAutocompleteLength)
                    return [2 /*return*/];
                return [4 /*yield*/, effects_1.put(HomeZhAction_1.default.setKeywordLoading(true))];
            case 5:
                _a.sent();
                return [4 /*yield*/, effects_1.call(getKeywordSuggestions_1.getKeywordSuggestions, keyword)];
            case 6:
                suggestions = _a.sent();
                return [4 /*yield*/, effects_1.put(HomeZhAction_1.default.setKeywordLoading(false))];
            case 7:
                _a.sent();
                return [4 /*yield*/, effects_1.put(HomeZhAction_1.default.setKeywordSuggestions(suggestions))];
            case 8:
                _a.sent();
                return [2 /*return*/];
        }
    });
};
var blurKeywordFields = function () {
    var element;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!(document !== undefined)) return [3 /*break*/, 2];
                element = document.getElementById('search-keyword-input');
                return [4 /*yield*/, effects_1.call(WindowApi_1.setElementBlur, element)];
            case 1:
                _a.sent();
                _a.label = 2;
            case 2: return [2 /*return*/];
        }
    });
};
var doScroll = function (id, direction) {
    var elm, width;
    return __generator(this, function (_a) {
        elm = document.getElementById(id);
        if (!elm)
            return [2 /*return*/];
        width = Array.from(elm.children)[0].clientWidth;
        elm.scrollBy({ left: width * direction, behavior: 'smooth' });
        return [2 /*return*/];
    });
};
var onFilterChanged = function () {
    var keyword, lang, type;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, effects_1.put(HomeZhAction_1.default.onSetKeywordActive(false))];
            case 1:
                _a.sent();
                return [4 /*yield*/, effects_1.select(getKeyword)];
            case 2:
                keyword = _a.sent();
                return [4 /*yield*/, effects_1.select(stateFilter_1.getCurrentLanguageCode)];
            case 3:
                lang = _a.sent();
                return [4 /*yield*/, effects_1.select(getSearchType)];
            case 4:
                type = _a.sent();
                return [4 /*yield*/, effects_1.call(WindowApi_1.setUrl, "/" + lang + "/property-search/" + type + "/" + format_1.default.normalize(keyword) + "-keyword")];
            case 5:
                _a.sent();
                return [2 /*return*/];
        }
    });
};
var onKeywordFocus = function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 4];
                return [4 /*yield*/, effects_1.take(HomeZhAction_1.default.ON_KEYWORD_FOCUS)];
            case 1:
                _a.sent();
                return [4 /*yield*/, effects_1.call(initKeywordHistories)];
            case 2:
                _a.sent();
                return [4 /*yield*/, effects_1.put(HomeZhAction_1.default.onSetKeywordActive(true))];
            case 3:
                _a.sent();
                return [3 /*break*/, 0];
            case 4: return [2 /*return*/];
        }
    });
};
var watchKeywordChanged = function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, effects_1.takeLatest(HomeZhAction_1.default.ON_KEYWORD_CHANGED, delaySuggestion)];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
};
var watchSaveKeywordHistory = function () {
    var payload, keyword;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 3];
                return [4 /*yield*/, effects_1.take(HomeZhAction_1.default.SET_KEYWORD)];
            case 1:
                payload = (_a.sent()).payload;
                keyword = payload;
                if (!keyword.trim() || keyword.length <= 1)
                    return [3 /*break*/, 0];
                return [4 /*yield*/, effects_1.call(SearchHistory_1.searchHistoryAdd, keyword)];
            case 2:
                _a.sent();
                return [3 /*break*/, 0];
            case 3: return [2 /*return*/];
        }
    });
};
var onSuggestionMouseEnter = function () {
    var payload;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 3];
                return [4 /*yield*/, effects_1.take(HomeZhAction_1.default.ON_SUGGESTION_MOUSE_ENTER)];
            case 1:
                payload = (_a.sent()).payload;
                return [4 /*yield*/, effects_1.put(HomeZhAction_1.default.setSuggestionFocus(payload))];
            case 2:
                _a.sent();
                return [3 /*break*/, 0];
            case 3: return [2 /*return*/];
        }
    });
};
var onSuggestionClick = function () {
    var payload, suggestion;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 5];
                return [4 /*yield*/, effects_1.take(HomeZhAction_1.default.ON_SUGGESTION_CLICK)];
            case 1:
                payload = (_a.sent()).payload;
                suggestion = payload;
                return [4 /*yield*/, effects_1.put(HomeZhAction_1.default.setKeyword(suggestion.name))];
            case 2:
                _a.sent();
                return [4 /*yield*/, effects_1.call(blurKeywordFields)];
            case 3:
                _a.sent();
                return [4 /*yield*/, effects_1.call(onFilterChanged)];
            case 4:
                _a.sent();
                return [3 /*break*/, 0];
            case 5: return [2 /*return*/];
        }
    });
};
var onHistoryMouseEnter = function () {
    var payload;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 3];
                return [4 /*yield*/, effects_1.take(HomeZhAction_1.default.ON_HISTORY_MOUSE_ENTER)];
            case 1:
                payload = (_a.sent()).payload;
                return [4 /*yield*/, effects_1.put(HomeZhAction_1.default.setHistoryFocus(payload))];
            case 2:
                _a.sent();
                return [3 /*break*/, 0];
            case 3: return [2 /*return*/];
        }
    });
};
var onHistoryClick = function () {
    var payload, history;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 4];
                return [4 /*yield*/, effects_1.take(HomeZhAction_1.default.ON_HISTORY_CLICK)];
            case 1:
                payload = (_a.sent()).payload;
                history = payload;
                return [4 /*yield*/, effects_1.put(HomeZhAction_1.default.setKeyword(history.name))];
            case 2:
                _a.sent();
                return [4 /*yield*/, effects_1.call(onFilterChanged)];
            case 3:
                _a.sent();
                return [3 /*break*/, 0];
            case 4: return [2 /*return*/];
        }
    });
};
var onSearchKeywordMouseEnter = function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 3];
                return [4 /*yield*/, effects_1.take(HomeZhAction_1.default.ON_SEARCH_KEYWORD_MOUSE_ENTER)];
            case 1:
                _a.sent();
                return [4 /*yield*/, effects_1.put(HomeZhAction_1.default.setSearchKeywordFocus(true))];
            case 2:
                _a.sent();
                return [3 /*break*/, 0];
            case 3: return [2 /*return*/];
        }
    });
};
var onSearchKeywordClick = function () {
    var keyword;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 5];
                return [4 /*yield*/, effects_1.take(HomeZhAction_1.default.ON_SEARCH_KEYWORD_CLICK)];
            case 1:
                _a.sent();
                return [4 /*yield*/, effects_1.select(getCurrentKeywordFocus)];
            case 2:
                keyword = _a.sent();
                if (!keyword)
                    return [3 /*break*/, 0];
                return [4 /*yield*/, effects_1.put(HomeZhAction_1.default.setKeyword(keyword))];
            case 3:
                _a.sent();
                return [4 /*yield*/, effects_1.call(onFilterChanged)];
            case 4:
                _a.sent();
                return [3 /*break*/, 0];
            case 5: return [2 /*return*/];
        }
    });
};
var onKeywordEscape = function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 4];
                return [4 /*yield*/, effects_1.take(HomeZhAction_1.default.ON_KEYWORD_ESCAPE)];
            case 1:
                _a.sent();
                return [4 /*yield*/, effects_1.put(HomeZhAction_1.default.onSetKeywordActive(false))];
            case 2:
                _a.sent();
                return [4 /*yield*/, effects_1.call(blurKeywordFields)];
            case 3:
                _a.sent();
                return [3 /*break*/, 0];
            case 4: return [2 /*return*/];
        }
    });
};
var onKeywordEnter = function () {
    var keyword;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 7];
                return [4 /*yield*/, effects_1.take(HomeZhAction_1.default.ON_KEYWORD_ENTER)];
            case 1:
                _a.sent();
                return [4 /*yield*/, effects_1.select(getCurrentKeywordFocus)];
            case 2:
                keyword = _a.sent();
                return [4 /*yield*/, effects_1.put(HomeZhAction_1.default.setKeyword(keyword))];
            case 3:
                _a.sent();
                return [4 /*yield*/, effects_1.call(onFilterChanged)];
            case 4:
                _a.sent();
                return [4 /*yield*/, effects_1.call(blurKeywordFields)];
            case 5:
                _a.sent();
                return [4 /*yield*/, effects_1.put(HomeZhAction_1.default.onSetKeywordActive(false))];
            case 6:
                _a.sent();
                return [3 /*break*/, 0];
            case 7: return [2 /*return*/];
        }
    });
};
var watchForSalePropertyMove = function () {
    var payload, direction;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 3];
                return [4 /*yield*/, effects_1.take(HomeZhAction_1.default.ON_SALE_PROPERTY_MOVE)];
            case 1:
                payload = (_a.sent()).payload;
                direction = payload;
                return [4 /*yield*/, effects_1.call(doScroll, 'for-sale-properties', direction)];
            case 2:
                _a.sent();
                return [3 /*break*/, 0];
            case 3: return [2 /*return*/];
        }
    });
};
var watchForRentPropertyMove = function () {
    var payload, direction;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 3];
                return [4 /*yield*/, effects_1.take(HomeZhAction_1.default.ON_RENT_PROPERTY_MOVE)];
            case 1:
                payload = (_a.sent()).payload;
                direction = payload;
                return [4 /*yield*/, effects_1.call(doScroll, 'for-rent-properties', direction)];
            case 2:
                _a.sent();
                return [3 /*break*/, 0];
            case 3: return [2 /*return*/];
        }
    });
};
var watchOnItemClicked = function () {
    var payload, item, lang, url;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 5];
                return [4 /*yield*/, effects_1.take(HomeZhAction_1.default.ON_ITEM_CLICK)];
            case 1:
                payload = (_a.sent()).payload;
                item = payload;
                return [4 /*yield*/, effects_1.select(stateFilter_1.getCurrentLanguageCode)];
            case 2:
                lang = _a.sent();
                return [4 /*yield*/, effects_1.call(propertyToUrl_1.propertyToUrl, lang, item.building, item.referenceId, item.type)];
            case 3:
                url = _a.sent();
                return [4 /*yield*/, effects_1.call(WindowApi_1.setUrl, url)];
            case 4:
                _a.sent();
                return [3 /*break*/, 0];
            case 5: return [2 /*return*/];
        }
    });
};
var rootHomeZhSagas = {
    rootPublicPageSagas: RootPublicPageSaga_1.rootPublicPageSagas,
    mobilePromoSagas: MobilePromoSaga_1.mobilePromoSagas,
    fgpPopSagas: FgpPopSagas_1.fgpPopSagas,
    onKeywordFocus: onKeywordFocus,
    watchKeywordChanged: watchKeywordChanged,
    watchSaveKeywordHistory: watchSaveKeywordHistory,
    onSuggestionMouseEnter: onSuggestionMouseEnter,
    onSuggestionClick: onSuggestionClick,
    onHistoryMouseEnter: onHistoryMouseEnter,
    onHistoryClick: onHistoryClick,
    onSearchKeywordMouseEnter: onSearchKeywordMouseEnter,
    onSearchKeywordClick: onSearchKeywordClick,
    onKeywordEscape: onKeywordEscape,
    onKeywordEnter: onKeywordEnter,
    watchForSalePropertyMove: watchForSalePropertyMove,
    watchForRentPropertyMove: watchForRentPropertyMove,
    watchOnItemClicked: watchOnItemClicked,
    watchInit: watchInit,
};
exports.rootHomeZhSagas = rootHomeZhSagas;
